document.querySelectorAll(".radio-option").forEach((radioOption) => {
  radioOption.addEventListener("click", function () {
    // Identify the circle container
    const circle = this.querySelector(".radio-custom");
    if (!circle) return;

    const oldRipple = this.querySelector(".ripple");
    if (oldRipple) {
      oldRipple.remove();
    }

    const labelRect = this.getBoundingClientRect();
    const circleRect = circle.getBoundingClientRect();

    const circleDiameter = Math.max(circleRect.width, circleRect.height);
    const size = circleDiameter * 1.5;

    const circleCenterX =
      circleRect.left - labelRect.left + circleRect.width / 2;

    const circleCenterY =
      circleRect.top - labelRect.top + circleRect.height / 2;

    const x = circleCenterX - size / 2;
    const y = circleCenterY - size / 2;

    const ripple = document.createElement("span");
    ripple.classList.add("ripple");
    ripple.style.width = ripple.style.height = size + "px";
    ripple.style.left = x + "px";
    ripple.style.top = y + "px";

    this.appendChild(ripple);
  });
});
